"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var shapes = _interopRequireWildcard(require("../shapes"));

var styles = _interopRequireWildcard(require("./documentCellStyles"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  outline: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var cellStyle = (0, _emotion.css)(_templateObject());

function isLeftOrRight(buttons) {
  /* eslint-disable-next-line no-bitwise */
  return buttons & 0x01 || buttons & 0x02;
}

var DocumentCellViewer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DocumentCellViewer, _PureComponent);

  function DocumentCellViewer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DocumentCellViewer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DocumentCellViewer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseDown", function (event) {
      var _this$props = _this.props,
          columnIndex = _this$props.columnIndex,
          rowIndex = _this$props.rowIndex,
          onDragStart = _this$props.onDragStart;

      if (isLeftOrRight(event.buttons)) {
        onDragStart(columnIndex, rowIndex);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseOver", function (event) {
      var _this$props2 = _this.props,
          columnIndex = _this$props2.columnIndex,
          rowIndex = _this$props2.rowIndex,
          onDragMove = _this$props2.onDragMove;

      if (isLeftOrRight(event.buttons)) {
        onDragMove(columnIndex, rowIndex);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDoubleClick", function (event) {
      var _this$props3 = _this.props,
          column = _this$props3.column,
          columnIndex = _this$props3.columnIndex,
          row = _this$props3.row,
          rowIndex = _this$props3.rowIndex,
          onEdit = _this$props3.onEdit;

      if (event.button === 0) {
        onEdit(columnIndex, rowIndex, row[column]);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(DocumentCellViewer, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          column = _this$props4.column,
          columnIndex = _this$props4.columnIndex,
          mode = _this$props4.mode,
          row = _this$props4.row,
          rowIndex = _this$props4.rowIndex,
          style = _this$props4.style;
      var className = styles.getClassName(columnIndex, rowIndex, mode);
      var data = row[column];
      /* eslint-disable jsx-a11y/no-static-element-interactions */

      /* eslint-disable jsx-a11y/mouse-events-have-key-events */

      return _react.default.createElement("div", {
        className: className,
        style: style,
        onDoubleClick: this.onDoubleClick,
        onMouseDown: this.onMouseDown,
        onMouseOver: this.onMouseOver
      }, _react.default.createElement("div", {
        className: cellStyle
      }, data));
      /* eslint-enable jsx-a11y/no-static-element-interactions */

      /* eslint-enable jsx-a11y/mouse-events-have-key-events */
    }
  }]);
  return DocumentCellViewer;
}(_react.PureComponent);

exports.default = DocumentCellViewer;
(0, _defineProperty2.default)(DocumentCellViewer, "propTypes", {
  column: shapes.column.isRequired,
  columnIndex: _propTypes.default.number.isRequired,
  mode: shapes.cellMode.isRequired,
  row: shapes.row.isRequired,
  rowIndex: _propTypes.default.number.isRequired,
  style: _propTypes.default.objectOf(_propTypes.default.any),
  onDragMove: _propTypes.default.func.isRequired,
  onDragStart: _propTypes.default.func.isRequired,
  onEdit: _propTypes.default.func.isRequired
});